import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule, MatDialogModule } from '@angular/material';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { routingModule } from './routing.module';
import { ChartsModule } from 'ng2-charts';
// Pages
import { MyApp } from './app.component';
import { LoginPage } from '../pages/login/login';
import { FindPrivacyPage } from '../pages/find-privacy/find-privacy';
import { TermsPage } from '../pages/terms/terms';
import { FindIdPage } from '../pages/find-privacy/find-id/find-id';
import { FindPwPage } from '../pages/find-privacy/find-pw/find-pw';
import { ChooseChildrenPage } from '../pages/choose-children/choose-children';
import { CommonLayout } from '../pages/common-layout/common-layout';
import { ReportPage } from '../pages/report/report';
import { AppointmentPage } from '../pages/appointment/appointment';
import { ExChartPage } from '../pages/ex-chart/ex-chart';
import { DetailPage } from '../pages/detail/detail';
import { TestChartPage } from '../pages/test-chart/test-chart';
import { ViewMorePage } from '../pages/view-more/view-more';
import { SettingPage } from '../pages/setting/setting';
import { NoticePage } from '../pages/notice/notice';
import { ChangePwdPage } from '../pages/setting/change-pwd/change-pwd';
// Components
import { Calendar } from '../components/appointment-calendar/calendar';
import { CalendarDay } from '../components/appointment-calendar/calendar-day';
import { TutorialScreen } from '../components/tutorial-screen/tutorial-screen';
import { ChildInfoBrain } from '../components/child-info-brain/child-info-brain';
import { ChildInfoLevel } from '../components/child-info-level/child-info-level';
import { ChildInfoPacket } from '../components/child-info-packet/child-info-packet';
import { ChildInfoPacketSummary } from
  '../components/child-info-packet-summary/child-info-packet-summary';
import { ChildInfoTitlebar } from '../components/child-info-titlebar/child-info-titlebar';
import { AppointmentAttendance } from
  '../components/appointment-event/appointment-attendance.component';
import { AppointmentEvent } from '../components/appointment-event/appointment-event.component';
import { AppointmentHolyday } from
  '../components/appointment-event/appointment-holyday.component';
import { AppointmentNoEvent } from
  '../components/appointment-event/appointment-noevent.component';
import { AppointmentPacket } from '../components/appointment-event/appointment-packet.component';
import { AppointmentPayment } from
  '../components/appointment-event/appointment-payment.component';
import { AppointmentStatus } from
  '../components/appointment-status/appointment-status.component';
import { TestChartPart } from '../components/test-chart-part/test-chart-part';
import { ListFlat } from '../components/list-flat/list-flat';
import { PhoneConsult } from '../components/phone-consult/phone-consult';
import { ContentsChannel } from '../components/contents-channel/contents-channel';
import { PolarChart } from '../components/polar-chart/polar-chart';
import { DoughnutChart } from '../components/doughnut-chart/doughnut-chart';
import { CustomModalService } from '../components/custom-modal/custom-modal';
import { CustomNavbar } from '../components/custom-navbar/custom-navbar';
// Directives
import { GraphPercent } from '../components/child-info-brain/graph-directives';
import { MarginLeft, ClipRight, PinImage } from '../components/child-info-level/bar-directives';
// Pipes
import { timeTransferPipe } from '../pipes/time-transfer.pipe';
// Providers
import { AjaxService } from '../services/ajax.service';
import { AlarmService } from '../services/alarm.service';
import { AppointmentService } from '../services/appointment.service';
import { AuthenticationService } from '../services/authentication.service';
import { ChildService } from '../services/child.service';
import { DeviceTokenService } from '../services/device-token.service';
import { ExerciseService } from '../services/exercise.service';
import { Globals } from '../services/globals';
import { ImageService } from '../services/image.service';
import { LocalStorageService } from '../services/local-storage.service';
import { NoticeController } from '../services/notice.controller';
import { NoticeService } from '../services/notice.service';
import { PacketService } from '../services/packet.service';
import { PushService } from '../services/push-service';
import { ReportService } from '../services/report.service';
import { SessionStorageService } from '../services/session-storage.service';
import { TestChartService } from '../services/test-chart.service';
import { ModalService } from '../services/modal.service';

@NgModule({
  declarations: [
    // Pages
    MyApp,
    LoginPage,
    FindPrivacyPage,
    TermsPage,
    FindIdPage,
    FindPwPage,
    CustomModalService,
    ChooseChildrenPage,
    CommonLayout,
    ReportPage,
    AppointmentPage,
    ExChartPage,
    DetailPage,
    TestChartPage,
    ViewMorePage,
    SettingPage,
    NoticePage,
    ChangePwdPage,
    // Components
    Calendar,
    CalendarDay,
    TutorialScreen,
    ChildInfoBrain,
    ChildInfoLevel,
    ChildInfoPacket,
    ChildInfoPacketSummary,
    ChildInfoTitlebar,
    AppointmentAttendance,
    AppointmentEvent,
    AppointmentHolyday,
    AppointmentNoEvent,
    AppointmentPacket,
    AppointmentPayment,
    AppointmentStatus,
    PolarChart,
    DoughnutChart,
    TestChartPart,
    ListFlat,
    PhoneConsult,
    CustomNavbar,
    ContentsChannel,
    // Directives
    GraphPercent,
    MarginLeft,
    ClipRight,
    PinImage,
    // Pipes
    timeTransferPipe,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatIconModule,
    MatTabsModule,
    MatDialogModule,
    BrowserAnimationsModule,
    routingModule,
    ChartsModule,
    HttpClientModule,
  ],
  bootstrap: [MyApp],
  entryComponents: [
    MyApp,
    CustomModalService,
  ],
  providers: [
    AjaxService,
    AlarmService,
    AppointmentService,
    AuthenticationService,
    ChildService,
    DeviceTokenService,
    ExerciseService,
    Globals,
    ImageService,
    LocalStorageService,
    NoticeController,
    NoticeService,
    PacketService,
    PushService,
    ReportService,
    SessionStorageService,
    TestChartService,
    ModalService,
    { provide: ErrorHandler, useClass: ErrorHandler },
  ],
})
export class AppModule {}
